import { useState, useEffect } from 'react';

export const useImage = (imageUrl) => {
  const [validUrl, setValidUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    setValidUrl(null);
    setError(null);

    if (!imageUrl) {
      setError(true);
      return undefined;
    }

    const img = new Image();
    img.onload = () => {
      if (cancelled) return;
      setValidUrl(imageUrl);
      setError(null);
    };
    img.onerror = () => {
      if (cancelled) return;
      setValidUrl(null);
      setError(true);
    };
    img.src = imageUrl;

    return () => {
      cancelled = true;
    };
  }, [imageUrl]);

  return { url: validUrl, error };
};
